import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getNavigationService } from 'services/getNavigationService'
import { getNavigation } from 'store/actions/navigation'
export const useNavigationMain = () => {
    const navigation = useSelector((state) => state.navigation)
    const dispatch = useDispatch()

    useEffect(() => {
        if (navigation === null) {
            const setNavigation = async () => {
                const navigation = await getNavigationService()
                dispatch(getNavigation(navigation))
            }
            setNavigation()
        }
    }, [dispatch, navigation])
    return {
        links: navigation ? navigation.main : [],
    }
}
